import { render, staticRenderFns } from "./WidgetButtonLink.vue?vue&type=template&id=0933660e&"
import script from "./WidgetButtonLink.vue?vue&type=script&lang=js&"
export * from "./WidgetButtonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports